export default "__VITE_ASSET__DuIBcQKC__"